import {
  Map,
} from 'immutable';
import {
  PURGE,
} from 'redux-persist';

import {
  RESET,
  SET_SELECTED_FORM,
  SET_FORM_MESSAGE,
} from './actionTypes';
import {
  FORMS__SIGN_IN,
} from './constants';

const initialState = Map({
  // Wybrany formularz.
  selectedForm: FORMS__SIGN_IN,
  formMessage: '',
});

export default (state = initialState, action) => {
  switch (action.type) {
    case PURGE:
      return initialState;

    case RESET:
      return initialState;

    case SET_SELECTED_FORM:
      return state
        .set('selectedForm', action.payload);

    case SET_FORM_MESSAGE:
      return state
        .set('formMessage', action.payload);

    default:
      return state;
  }
};
